export const locationData = [
  {
    title: "Krishna temple",
    description: `Krishna Temple is a historic Hindu temple located in the city of Patan, Nepal. 
      The temple is dedicated to Lord Krishna and is a significant religious and cultural site. 
      It is known for its intricate architecture and beautiful carvings, making it a popular 
      tourist attraction. The temple's history dates back to ancient times and is a testament to 
      Nepal's rich cultural heritage.

      The Krishna Temple is a place of worship and a center for various religious ceremonies 
      and festivals. Devotees and tourists alike visit the temple to pay their respects and 
      experience the spiritual ambiance. The temple's peaceful surroundings provide a serene 
      environment for meditation and reflection.

      The temple's architectural details, including its wooden carvings, stone sculptures, and 
      ornate decorations, showcase the exquisite craftsmanship of the local artisans. The temple's 
      location in the heart of Patan city adds to its charm, making it a must-visit destination for 
      anyone exploring Nepal's cultural treasures.

      Whether you are a history enthusiast, a religious pilgrim, or simply a traveler looking to 
      immerse yourself in Nepal's vibrant culture, the Krishna Temple is a place where you can 
      experience the beauty of spirituality and artistry in one stunning location.`,
    images: [
      "KrishnaTemple.jpeg",
      "krishna_temple_1.jpeg",
      "krishna_temple_2.jpeg",
      "krishna_temple_3.png",
    ],
    mapUrl: "https://maps.google.com/?q=27.6752289, 85.3219734",
    latitude: 27.6752289,
    longitude: 85.3219734,
    location: "Patan, Lalitpur",
    youtube: "https://youtu.be/pacHRO16VOg",
    panellumImage: [
      "sundarichowk1.jpg",
      "sundarichowk2.jpg",
      "sundarichowk3.jpg",
      "sundarichowk4.jpg",
    ],
  },
  {
    title: "Bhag bhairav",
    description: `Bhag Bhairav is an ancient temple dedicated to the god Bhairav located in the 
      historic town of Kirtipur, Nepal. This temple holds great religious significance for 
      devotees and is a symbol of the town's rich cultural heritage.

      The temple is known for its traditional Newari architecture and intricate woodcarvings, 
      reflecting the artistic skills of the local craftsmen. Bhag Bhairav is not only a place 
      of worship but also a cultural hub where various festivals and rituals are celebrated with 
      great enthusiasm.

      Visitors to Bhag Bhairav can explore the temple's premises, admire its architecture, and 
      participate in religious ceremonies. The temple is a place of spiritual solace, offering 
      a peaceful escape from the bustling city life.

      Kirtipur, with its narrow streets, ancient buildings, and a backdrop of lush hills, 
      provides a unique setting for Bhag Bhairav. The temple's location within this historical 
      town adds to its charm, making it a must-visit destination for those interested in Nepal's 
      cultural and religious heritage.`,
    images: ["bhag_bhairav_1.jpg", "bhag_bhairav_2.jpeg"],
    mapUrl: "https://maps.google.com/?q=27.6794234, 85.2739021",
    latitude: 27.6794234,
    longitude: 85.2739021,
    location: "Kirtipur, Kathmandu",
    youtube: "https://www.youtube.com/watch?v=WN4-8-jBUG0",
    panellumImage: [
      "sundarichowk1.jpg",
      "sundarichowk2.jpg",
      "sundarichowk3.jpg",
      "sundarichowk4.jpg",
    ],
  },
  {
    title: "Uma maheshwor temple",
    description: `Uma Maheshwor Temple is a sacred Hindu temple situated in the picturesque town of Kirtipur, Nepal. 
      The temple is dedicated to Lord Shiva and Goddess Parvati and is an important pilgrimage site for 
      devotees.

      The temple's architecture is a blend of traditional Newari design and artistic detailing, 
      making it a marvel to behold. It is adorned with beautiful woodcarvings and sculptures that 
      showcase the exceptional craftsmanship of the region.

      Uma Maheshwor Temple is not only a place of worship but also a cultural center where various 
      religious and cultural festivals are celebrated with grandeur. The temple's serene environment 
      makes it a tranquil spot for meditation and spiritual reflection.

      Kirtipur, known for its historical significance and stunning landscape, offers a perfect 
      backdrop to the Uma Maheshwor Temple. Visitors can explore the temple, participate in rituals, 
      and immerse themselves in the spiritual aura of the place.

      Whether you are a religious pilgrim, an art enthusiast, or a traveler looking to experience 
      the cultural riches of Nepal, the Uma Maheshwor Temple in Kirtipur is a place where you can 
      connect with the divine and appreciate the artistic heritage of the region.`,
    images: [
      "Umamaheswori.jpeg",
      "uma_maheshwor_1.jpeg",
      "uma_maheshwor_2.jpeg",
      "uma_maheshwor_3.jpeg",
      "uma_maheshwor_4.jpeg",
    ],
    mapUrl: "https://maps.google.com/?q=27.680058, 85.272057",
    latitude: 27.680058,
    longitude: 85.272057,
    location: "Kirtipur, Kathmandu",
    youtube: "https://www.youtube.com/watch?v=WN4-8-jBUG0",
    panellumImage: [
      "sundarichowk1.jpg",
      "sundarichowk2.jpg",
      "sundarichowk3.jpg",
      "sundarichowk4.jpg",
    ],
  },
  {
    title: "Hiranya varna mahavihar",
    description: `Hiranya Varna Mahavihar, also known as the Golden Temple, is a Buddhist monastery located 
      in Lalitpur, Nepal. This majestic temple is renowned for its stunning architecture, intricate 
      woodcarvings, and a rich cultural heritage.

      The Golden Temple stands as a symbol of Buddhist spirituality and is a place of worship, meditation, 
      and education. Visitors can explore the temple's courtyards, stupas, and shrines while enjoying 
      the serene ambiance.

      The temple's main attraction is its golden facade, which glistens in the sunlight. It's a tranquil 
      retreat within the bustling city of Lalitpur and provides a unique opportunity to experience the 
      serenity of Buddhist traditions and artistry.

      Whether you are a Buddhist practitioner, a history enthusiast, or a traveler seeking cultural 
      enrichment, the Hiranya Varna Mahavihar of Lalitpur is a place where you can immerse yourself in the 
      beauty of Buddhist culture and spirituality.`,
    images: [
      "hiranya_varna_mahavihar_1.jpeg",
      "hiranya_varna_mahavihar_2.jpeg",
    ],
    mapUrl: "https://maps.google.com/?q=27.6735697, 85.3223784",
    latitude: 27.6735697,
    longitude: 85.3223784,
    location: "Patan, Lalitpur",
    youtube: "https://www.youtube.com/watch?v=-Tr_Rig1u8I",

    panellumImage: [
      "sundarichowk1.jpg",
      "sundarichowk2.jpg",
      "sundarichowk3.jpg",
      "sundarichowk4.jpg",
    ],
  },
  {
    title: "Sundari chowk",
    description: `Sundari Chowk is a historic courtyard located in the heart of Patan, Nepal.
      This exquisite courtyard is known for its architectural beauty and cultural significance.

      Sundari Chowk features intricate woodcarvings, traditional Newari architecture, and a
      serene atmosphere. The courtyard is surrounded by stunning structures, including temples
      and palaces, making it a captivating destination for visitors.

      The detailed craftsmanship of Sundari Chowk reflects the rich artistic heritage of the
      region. The courtyard is not only a visual delight but also a peaceful space where
      visitors can experience the cultural charm of Patan.

      Whether you are an architecture enthusiast, a history buff, or a traveler seeking the
      authentic cultural experience, Sundari Chowk is a must-visit destination within the
      vibrant city of Patan.`,
    images: [
      "sundari_chowk_3.jpeg",
      "sundari_chowk_1.jpeg",
      "sundari_chowk_2.jpeg",
      "sundari_chowk_4.jpeg",
    ],
    mapUrl: "https://maps.google.com/?q=27.673662, 85.321977",
    latitude: 27.673662,
    longitude: 85.321977,
    location: "Patan Durbar Square, Lalitpur",
    youtube: "https://www.youtube.com/watch?v=WN4-8-jBUG0",
    panellumImage: [
      "sundarichowk1.jpg",
      "sundarichowk2.jpg",
      "sundarichowk3.jpg",
      "sundarichowk4.jpg",
    ],
  },
  {
    title: "Mul chowk",
    description: `Mul Chowk is a historic courtyard situated in Bhaktapur, Nepal.
      This charming chowk is known for its cultural significance and traditional architecture.

      Mul Chowk features intricate woodcarvings, a central water fountain, and surrounding
      structures that showcase the artistic craftsmanship of the Newari people. The chowk
      is a peaceful retreat within the bustling city of Bhaktapur.

      The courtyard is often used for various cultural events, ceremonies, and festivals.
      Visitors to Mul Chowk can explore the details of the woodcarvings, appreciate the
      cultural ambiance, and witness the vibrant life of Bhaktapur.

      Whether you are a cultural explorer, a photography enthusiast, or a traveler seeking
      authentic experiences, Mul Chowk offers a glimpse into the rich heritage of Bhaktapur.`,
    images: [
      "mul_chowk_6.jpeg",
      "mul_chowk_5.jpeg",
      "mul_chowk_3.jpeg",
      "mul_chowk_4.jpeg",
      "mul_chowk_2.jpeg",

      // "mul_chowk_1.webp",
    ],
    mapUrl: "https://maps.google.com/?q=27.672854, 85.428495",
    latitude: 27.672854,
    longitude: 85.428495,
    location: "Mul Chowk, Lalitpur",
    youtube: "https://www.youtube.com/watch?v=NYt3ISwC6jk",
    panellumImage: [
      "mulchowk1.jpg",
      "mulchowk2.jpg",
      "mulchowk3.jpg",
      "mulchowk4.jpg",
    ],
  },
];
